export const password =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`])[A-Za-z\d!@#$%^&*()_+.]{8,}$/

export const phone = /^(\+[0-9]{2})?([0-9]{9,15})$/
export const phoneNumber = /^[0-9]{9}$/
export const phoneNumberEN = /^[0-9]{10}$/
export const phoneNumberDE = /^[0-9]{10,11}$/

export const email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const nip = /^PL[0-9]{10}$/

export const postalCode = /^[0-9]{2}-[0-9]{3}$/

export const only_number = /^\d+$/
export default { password, phone, email, nip, only_number }
